export default "__VITE_ASSET__Cmzwr5yP__"